var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{staticStyle:{"width":"100%","height":"100vh","margin":"0","padding":"0","border":"none"},attrs:{"src":"https://inter.sm-center.ru/#/dom-24"}})])
}]

export { render, staticRenderFns }